import { type useSingleton } from '@tippyjs/react';
import React, { useContext } from 'react';

type SingletonObject = ReturnType<typeof useSingleton>[1];

const TippyTargetContext = React.createContext<SingletonObject | undefined>(
  undefined
);

export const TippyTargetProvider = TippyTargetContext.Provider;

export const useTippyTarget = () => {
  const singleton = useContext(TippyTargetContext);

  if (!singleton) {
    throw new Error('useTippyTarget must be used within a TippyTargetProvider');
  }

  return singleton;
};
